import NoTableResults from '@shared/components/tables/table-components/no-table-results';
import { html } from '@shared/utils/rendering/html';

export const ClosedPeriod = ({ message, ...props }) => {
    return html` <${NoTableResults} message=${{ text: message || 'This period is closed.' }} /> `;
};
